import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseFullscreenComponent } from '../../../../../@fuse/components/fullscreen';
import { FuseHorizontalNavigationComponent, FuseVerticalNavigationComponent } from '../../../../../@fuse/components/navigation';
import { ModernLayoutComponent } from './modern.component';
import { CommonModule } from '@angular/common';

import { LanguagesModule } from '../../../common/languages/languages.module';
import { UserModule } from '../../../common/user/user.module';
import { TenantModule } from '../../../common/tenant/tenant.module';

@NgModule({ declarations: [
        ModernLayoutComponent
    ],
    exports: [
        ModernLayoutComponent
    ], imports: [CommonModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenComponent,
        FuseHorizontalNavigationComponent,
        FuseVerticalNavigationComponent,
        LanguagesModule,
        UserModule,
        TenantModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ModernLayoutModule {
}
